export default [
  { channel: 'Instagram', href: 'https://www.instagram.com/emerald_cloud_flower/', icon: 'mdi-instagram' },
  { channel: 'Twitter', href: 'https://twitter.com/EmeraldCloud_F', icon: 'mdi-twitter' },
  { channel: 'Kakao', href: 'https://pf.kakao.com/_KYqDT', icon: 'mdi-chat'},
]